import type { Inn } from "./derive";
import type { SegOpt } from "./shared";

export const innOpts = (inns: Inn[]): SegOpt[] =>
  inns.map((i, idx) => ({
    key: String(idx),
    label: (
      <>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: i.team.color, display: "inline-block" }} />
        {i.team.name} <span className="c">{i.runs}/{i.wkts}</span>
      </>
    ),
  }));
